function BlogSection() {
  const blogPosts = [
    {
      title: "Top Car Transport Airport Services for Seamless Travel Experience",
      image: "https://empirelimotransfer.com/wp-content/uploads/2025/12/Top-Car-Transport-Airport-Services-for-Seamless-Travel-Experience.png",
      link: "/blog"
    },
    {
      title: "Top Private Car Airport Services for Reliable and Safe Transfers",
      image: "https://empirelimotransfer.com/wp-content/uploads/2025/12/Private-Car-Airport-Service-Overview.png",
      link: "/blog"
    },
    {
      title: "Top Airport Car Service: Reliable Transportation for Every Traveler",
      image: "https://empirelimotransfer.com/wp-content/uploads/2025/12/Introduction-to-Airport-Car-Service.png",
      link: "/blog"
    }
  ];

  return (
    <section className="bg-white py-6 md:py-8 lg:py-12 xl:py-16 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1200px] mx-auto">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 md:mb-8 lg:mb-12 gap-3 md:gap-4">
          <div className="mb-2 lg:mb-0">
            <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-black leading-tight">Our Latest Blog Posts</h2>
          </div>
          <a 
            href="/blog" 
            className="bg-black text-white px-3 md:px-4 lg:px-6 py-2 md:py-2.5 lg:py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors flex items-center gap-2 whitespace-nowrap text-xs md:text-sm lg:text-base"
          >
            View All
            <svg className="w-3 h-3 md:w-4 md:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </a>
        </div>

        {/* Blog Post Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {blogPosts.map((post, index) => (
            <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow">
              {/* Blog Image */}
              <div className="h-40 md:h-48 lg:h-56 xl:h-64 overflow-hidden bg-gray-200">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div class="w-full h-full bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center"><span class="text-6xl">📰</span></div>';
                  }}
                />
              </div>
              
              {/* Blog Content */}
              <div className="p-3 md:p-4 lg:p-6">
                <h3 className="text-sm md:text-base lg:text-lg xl:text-2xl font-bold text-black mb-3 md:mb-4 lg:mb-6 leading-tight min-h-[2.5rem] md:min-h-[3rem]">{post.title}</h3>
                <a 
                  href={post.link}
                  className="inline-block bg-black text-white px-3 md:px-4 lg:px-6 py-2 md:py-2.5 lg:py-3 rounded-lg font-semibold hover:bg-gray-800 transition-colors text-xs md:text-sm lg:text-base"
                >
                  Learn more
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default BlogSection;











